// @ts-check

import { getNextAvailableVoucherDate } from '@/api/entries'
import { stringToDate } from '@/helpers/dates'

export const getDocumentDateRange = async () => {
  const dates = await getNextAvailableVoucherDate()

  return {
    min: stringToDate(dates.min_document_add_date),
    max: stringToDate(dates.max_document_add_date),
    min_edit: stringToDate(dates.min_document_edit_date),
    max_edit: stringToDate(dates.max_document_edit_date)
  }
}

export default {}
